import { Button } from '@mui/material';
import { toastError, toastSuccess } from '@onestep/coreui/Toast';
import { observer } from 'mobx-react-lite';
import { useParams } from 'react-router';

import clinicalEventConfirmAlert from '../clinicalEventConfirmAlert';
import alertStyles from '../clinicalEventConfirmAlert/index.module.scss';
import useRtmEventsService from '../service';

const VoidClinicalEvent = ({ uuid, isMonitoring }: { uuid: string; isMonitoring?: boolean }) => {
  const { patientUuid = '' } = useParams<{ patientUuid: string }>();
  const { allowVoid, voidAction } = useRtmEventsService(patientUuid);

  const voidEvent = async () => {
    try {
      await voidAction({ uuid, isMonitoring });
      toastSuccess({ content: 'Event voided successfully!' });
    } catch {
      toastError({ content: 'Failed to void event!' });
    }
  };
  const confirmVoid = () =>
    clinicalEventConfirmAlert({
      title: 'Void event',
      body: `You're about to void this event permanently. This action cannot be undone.`,
      primaryBtnText: 'Void',
      onClick: voidEvent,
      classes: {
        body: alertStyles.void,
        btn: alertStyles.void,
      },
    });

  return (
    <Button
      variant={'outlined'}
      disabled={!allowVoid(uuid)}
      color="error"
      className={'mr-2'}
      onClick={confirmVoid}
    >
      Void
    </Button>
  );
};

export default observer(VoidClinicalEvent);
